import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import {
  Button,
  Col,
  Dropdown,
  FormControl,
  FormLabel,
  Row,
  Spinner,
  Card,
  Badge,
  Modal,
} from "react-bootstrap";
import ReusableTable from "../../components/ReusableTable";
import { toast } from "react-toastify";
import axios from "../../api/axios";
import Select from "react-select";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MenuIngredients = () => {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const { access } = useSelector((state) => state.login);
  const { email } = useSelector((state) => state.login);
  const [menuAccess, setMenuAccess] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (Array.isArray(access)) {
      const filteredAccess = access?.filter((perm) =>
        perm?.startsWith("MenuIngredients:")
      );
      setMenuAccess(filteredAccess);
    }
  }, [access]);

  const accessToken = localStorage.getItem("authToken");
  // const [searchText, setSearchText] = useState("");
  const [searchText, setSearchText] = useState(() => sessionStorage.getItem("mi_searchText") || "");
  const [isTouched, setIsTouched] = useState(false);
  const [ingredientsList, setIngredientsList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false);

  // const [categoryId, setCategoryId] = useState("");
  // const [isClicked, setIsClicked] = useState(false);

  const [categoryId, setCategoryId] = useState(() => sessionStorage.getItem("mi_categoryId") || "");
  const [isClicked, setIsClicked] = useState(() => sessionStorage.getItem("mi_isClicked") === "true");

  const [rawMaterialList, setRawMaterialList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [productIngredientId, setProductIngredientId] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [addons, setAddons] = useState([]);
  const [downloadLoading, setDownloadLoading] = useState(false); // ✅ NEW

  const categoryOptions = categoryList?.map((cat) => ({
    value: cat._id,
    label: cat.name,
  }));

  // ✅ Helper to get selected category name
  const selectedCategoryName =
    categoryOptions?.find((opt) => opt.value === categoryId)?.label || "All";

  const getConditionalAddonText = (conditionalAddon) => {
    console.log("Conditional Addons :", conditionalAddon);

    const matchedAddon = addons?.find(
      (addon) => addon?._id === conditionalAddon?.addonId?._id
    );

    const matchedAddonValue = matchedAddon?.addonValues?.find(
      (val) => val?._id === conditionalAddon?.addonValueId
    );

    return {
      addonTitle: matchedAddon?.title || "Unknown Addon",
      addonValue: matchedAddonValue?.value || "Unknown Value",
      quantity: conditionalAddon?.quantity,
    };
  };

  const IngredientDetails = ({ row }) => {
    const collapseId = `ingredients-collapse-${row?._id}`;

    return (
      <div className="w-100">
        <button
          type="button"
          className="btn btn-light w-100 text-start border rounded-3 p-2"
          data-bs-toggle="collapse"
          data-bs-target={`#${collapseId}`}
          aria-expanded="false"
          aria-controls={collapseId}
          style={{
            background: "#f8fafc",
            borderColor: "#e2e8f0",
            boxShadow: "none",
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-2">
            <div className="d-flex flex-column">
              <span
                className="fw-semibold"
                style={{ fontSize: "0.9rem", color: "#0f172a" }}
              >
                {row?.product?.name || "—"}
              </span>
              <small style={{ fontSize: "0.72rem", color: "#64748b" }}>
                Click to view ingredients
              </small>
            </div>

            <div className="d-flex align-items-center gap-2">
              <Badge
                bg="light"
                text="dark"
                pill
                style={{
                  fontSize: "0.7rem",
                  border: "1px solid #e2e8f0",
                  padding: "0.4rem 0.6rem",
                }}
              >
                {row?.rawMaterials?.length || 0} items
              </Badge>
              <i
                className="ri-arrow-down-s-line"
                style={{ fontSize: "1rem", color: "#64748b" }}
              ></i>
            </div>
          </div>
        </button>

        <div className="collapse mt-2" id={collapseId}>
          <div
            className="border rounded-3 p-2"
            style={{ backgroundColor: "#ffffff", borderColor: "#e2e8f0" }}
          >
            {row?.rawMaterials && row?.rawMaterials?.length > 0 ? (
              <div className="d-flex flex-column gap-2">
                {row?.rawMaterials?.map((rm, index) => (
                  <div
                    key={index}
                    className="rounded-3 p-2"
                    style={{
                      background: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                      <div>
                        <div
                          className="fw-semibold"
                          style={{ fontSize: "0.82rem", color: "#0f172a" }}
                        >
                          {index + 1}. {rm?.rawMaterial?.name || "—"}
                        </div>
                        <div
                          className="mt-1"
                          style={{ fontSize: "0.72rem", color: "#64748b" }}
                        >
                          Unit: {rm?.rawMaterial?.unit || "—"}
                        </div>
                      </div>

                      <div className="text-end">
                        <div
                          className="fw-semibold"
                          style={{ fontSize: "0.82rem", color: "#0E4961" }}
                        >
                          {rm?.quantity || "—"} {rm?.rawMaterial?.unit || ""}
                        </div>
                        {rm?.addonValueDetails?.value ? (
                          <div
                            className="mt-1"
                            style={{ fontSize: "0.72rem", color: "#b45309" }}
                          >
                            {rm?.addonId?.title}: {rm?.addonValueDetails?.value}
                          </div>
                        ) : (
                          <div
                            className="mt-1"
                            style={{ fontSize: "0.72rem", color: "#94a3b8" }}
                          >
                            No addon condition
                          </div>
                        )}
                      </div>
                    </div>

                    {rm?.conditionalAddons?.length > 0 && (
                      <div
                        className="mt-2 pt-2"
                        style={{ borderTop: "1px dashed #e2e8f0" }}
                      >
                        <div
                          className="mb-2 fw-semibold"
                          style={{ fontSize: "0.72rem", color: "#92400e" }}
                        >
                          Conditional Addons
                        </div>

                        <div className="d-flex flex-column gap-1">
                          {rm.conditionalAddons.map((cond, condIndex) => {
                            const condData = getConditionalAddonText(cond);

                            return (
                              <div
                                key={condIndex}
                                className="rounded-2 px-2 py-1"
                                style={{
                                  backgroundColor: "#fff7ed",
                                  border: "1px solid #fed7aa",
                                }}
                              >
                                <div
                                  className="fw-medium"
                                  style={{
                                    fontSize: "0.72rem",
                                    color: "#9a3412",
                                  }}
                                >
                                  {condData.addonTitle}: {condData.addonValue}
                                </div>
                                <div
                                  style={{
                                    fontSize: "0.7rem",
                                    color: "#7c2d12",
                                  }}
                                >
                                  Qty: {condData.quantity}{" "}
                                  {rm?.rawMaterial?.unit || ""}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-3">
                <i
                  className="ri-inbox-archive-line"
                  style={{ fontSize: "1.1rem", color: "#cbd5e1" }}
                ></i>
                <div
                  className="mt-1"
                  style={{ fontSize: "0.75rem", color: "#94a3b8" }}
                >
                  No ingredients available
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const columns = [
    {
      header: "Sr.No",
      accessor: "serialNumber",
      render: (_, row) => (
        <div className="text-center fw-semibold" style={{ fontSize: "0.82rem" }}>
          {row?.serialNumber || "—"}
        </div>
      ),
    },
    {
      header: "Menu Item",
      accessor: "product.name",
      render: (_, row) => <IngredientDetails row={row} />,
    },
    {
      header: "Actions",
      accessor: null,
      render: (_, row) => (
        <div className="d-flex justify-content-center">
          <Dropdown>
            <Dropdown.Toggle
              variant="link"
              size="sm"
              className="border-0 shadow-none p-0"
            >
              <i
                className="ri-more-2-fill"
                style={{ fontSize: "1rem", color: "#475569" }}
              ></i>
            </Dropdown.Toggle>

            <Dropdown.Menu align="end" className="shadow-sm border-0 rounded-3">
              {(menuAccess?.includes("MenuIngredients:update") ||
                email === "contact@xpansecafe.com") && (
                  <Dropdown.Item
                    onClick={() =>
                      navigate(`/menu/edit-menu-ingredients/${row._id}`)
                    }
                    className="py-2"
                    style={{ fontSize: "0.82rem" }}
                  >
                    <i className="ri-edit-2-line me-2 text-primary"></i>
                    Edit
                  </Dropdown.Item>
                )}

              {(menuAccess?.includes("MenuIngredients:delete") ||
                email === "contact@xpansecafe.com") && (
                  <Dropdown.Item
                    onClick={() => handleDeleteModal(row)}
                    className="py-2"
                    style={{ fontSize: "0.82rem" }}
                  >
                    <i className="ri-delete-bin-line me-2 text-danger"></i>
                    Delete
                  </Dropdown.Item>
                )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const getIngredients = async (catId) => {
    setIsLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      const response = await axios.get("recipe", { headers });
      response?.data?.data?.recieps?.forEach((item, index) => {
        item.serialNumber = index + 1;
      });

      if (catId === "" || catId === undefined) {
        setFilteredData(response?.data?.data?.recieps);
        setIngredientsList(response?.data?.data?.recieps);
      } else {
        let filteredRecipes = response?.data?.data?.recieps?.filter(
          (rec) => rec?.product?.category?._id === catId
        );
        setFilteredData(filteredRecipes);
        setIngredientsList(filteredRecipes);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getCategoryList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("masters/category/get", { headers });

      if (response?.data?.status === true) {
        setCategoryList(response?.data?.data?.categories);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    }
  };

  const getProductsListForEdit = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("product", { headers });
      if (response?.data?.status === true) {
        setProductsList(response?.data?.data?.products);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    }
  };

  const getAddons = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("addons?page=1&limit=1000", { headers });
      setAddons(response?.data?.data?.addons);
    } catch (error) {
      console.log("error :", error);
    }
  };

  const getRawMaterials = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("raw-material", { headers });

      if (response?.data?.status === true) {
        response?.data?.data?.rawMaterials?.forEach((item, index) => {
          item.serialNumber = index + 1;
        });
        setRawMaterialList(response?.data?.data?.rawMaterials);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    }
  };

  const handleOpenAddScreen = () => {
    navigate("/menu/add-menu-ingredients");
  };

  const handleSearchChange = (e) => {
    setIsTouched(true);
    setSearchText(e.target.value);
  };

  const handleSubmitData = async (e) => {
    e.preventDefault();
    if (!categoryId) {
      toast.warning("Please select a category first");
      return;
    }
    setIsClicked(true);
    setIsSubmitBtnLoading(true);
    await getIngredients(categoryId);
    setIsSubmitBtnLoading(false);
  };

  const handleDeleteModal = (data) => {
    const ingredientId = data?._id;
    setProductIngredientId(ingredientId);
    setOpenDeleteModal(true);
  };

  const handleDeleteProductIngredient = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const data = {
        _id: productIngredientId,
      };
      const response = await axios.delete("recipe", { data, headers });
      if (response?.data?.status === true) {
        toast.success("Ingredient deleted successfully");
        getIngredients(categoryId);
        setOpenDeleteModal(false);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ NEW: Download handler
  const handleDownload = async () => {
    if (!categoryId) {
      toast.warning("Please select a category before downloading.");
      return;
    }

    setDownloadLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      const params = {
        ...(categoryId && { categoryId }),
        isDownload: true, // ✅ Key param
      };

      const response = await axios.get("recipe", {
        headers,
        params,
        responseType: "blob",
      });

      // ✅ File name: "<Category Name> Menu Ingredients"
      const filename = `${selectedCategoryName} Menu Ingredients.xlsx`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success(`"${filename}" downloaded successfully!`, {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
    } catch (error) {
      toast.error("Failed to download file. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
    } finally {
      setDownloadLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    setRowsPerPage(rowsPerPage);
    setPage(1);
  };

  const getPaginatedData = () => {
    const startIndex = (page - 1) * rowsPerPage;
    const endIndex = startIndex + Number(rowsPerPage);
    return filteredData?.slice(startIndex, endIndex);
  };

  useEffect(() => {
    getCategoryList();
    getRawMaterials();
    getProductsListForEdit();
    getAddons();
  }, []);

  useEffect(() => {
    if (searchText && isTouched) {
      const result = ingredientsList?.filter((item) =>
        item?.product?.name?.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(result);
    } else {
      setFilteredData(ingredientsList);
    }
  }, [searchText, ingredientsList]);

  // Add this after the existing useEffects
  useEffect(() => {
    sessionStorage.setItem("mi_categoryId", categoryId);
  }, [categoryId]);

  useEffect(() => {
    sessionStorage.setItem("mi_isClicked", isClicked);
  }, [isClicked]);

  // Add this useEffect after the one above
  useEffect(() => {
    const savedCategoryId = sessionStorage.getItem("mi_categoryId");
    const savedIsClicked = sessionStorage.getItem("mi_isClicked") === "true";

    if (savedCategoryId || savedIsClicked) {
      getIngredients(savedCategoryId);
    }
  }, []); // runs once on mount

  useEffect(() => {
    sessionStorage.setItem("mi_searchText", searchText);
  }, [searchText]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />

      <div
        className="main main-app p-2 p-lg-3"
        style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}
      >
        <div className="container-fluid px-0">
          {/* Page Header */}
          <Card className="border-0 shadow-sm rounded-1 mb-3">
            <Card.Body className="p-3 p-lg-3">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <h5 className="mb-1 fw-bold" style={{ color: "#0f172a" }}>
                    MENU INGREDIENTS
                  </h5>
                  <p
                    className="mb-0"
                    style={{ fontSize: "0.85rem", color: "#64748b" }}
                  >
                    Manage recipe ingredients for your menu items.
                  </p>
                </div>

                {(menuAccess?.includes("MenuIngredients:add") ||
                  email === "contact@xpansecafe.com") && (
                    <Button
                      onClick={handleOpenAddScreen}
                      className="d-flex align-items-center gap-2 px-3"
                      style={{
                        backgroundColor: "#0E4961",
                        borderColor: "#0E4961",
                        fontSize: "0.85rem",
                      }}
                    >
                      <i className="ri-add-line"></i>
                      Add New
                    </Button>
                  )}
              </div>
            </Card.Body>
          </Card>

          {/* Filters */}
          <Card className="border-0 shadow-sm rounded-1 mb-3">
            <Card.Body className="p-3">
              <Row className="g-3 align-items-end">
                <Col md={4}>
                  <FormLabel
                    className="fw-semibold mb-2"
                    style={{ fontSize: "0.82rem", color: "#334155" }}
                  >
                    Category
                  </FormLabel>
                  <Select
                    name="categoryFilter"
                    options={categoryOptions}
                    value={
                      categoryOptions?.find(
                        (option) => option.value === categoryId
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setCategoryId(selectedOption ? selectedOption.value : "")
                    }
                    placeholder="Select category"
                    isClearable
                    classNamePrefix="react-select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "35px",
                        borderColor: "#e2e8f0",
                        boxShadow: "none",
                        fontSize: "0.85rem",
                        "&:hover": {
                          borderColor: "#cbd5e1",
                        },
                      }),
                      menu: (base) => ({
                        ...base,
                        fontSize: "0.85rem",
                        zIndex: 20,
                      }),
                      option: (base) => ({
                        ...base,
                        fontSize: "0.85rem",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "0.85rem",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "0.85rem",
                      }),
                    }}
                  />
                </Col>

                <Col md={3}>
                  <FormLabel
                    className="fw-semibold mb-2"
                    style={{ fontSize: "0.82rem", color: "#334155" }}
                  >
                    Search Menu
                  </FormLabel>
                  <div className="position-relative">
                    <FormControl
                      type="text"
                      value={searchText}
                      onChange={handleSearchChange}
                      placeholder="Search by menu name..."
                      style={{
                        height: "35px",
                        fontSize: "0.85rem",
                        borderColor: "#e2e8f0",
                        paddingLeft: "2.3rem",
                        paddingRight: "2.3rem",
                      }}
                    />
                    <i
                      className="ri-search-line position-absolute top-50 translate-middle-y"
                      style={{
                        left: "12px",
                        fontSize: "0.95rem",
                        color: "#94a3b8",
                      }}
                    ></i>

                    {searchText && (
                      <button
                        type="button"
                        onClick={() => setSearchText("")}
                        className="btn p-0 border-0 bg-transparent position-absolute top-50 end-0 translate-middle-y me-3"
                      >
                        <i
                          className="ri-close-line"
                          style={{ fontSize: "1rem", color: "#94a3b8" }}
                        ></i>
                      </button>
                    )}
                  </div>
                </Col>

                <Col md={2} className="d-flex align-items-end">
                  <Button
                    className="w-100 fw-semibold"
                    variant="success"
                    onClick={handleSubmitData}
                    disabled={isSubmitBtnLoading}
                    style={{ height: "35px", fontSize: "0.85rem" }}
                  >
                    {isSubmitBtnLoading ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Loading...
                      </>
                    ) : (
                      <>
                        <i className="ri-search-line me-2"></i>
                        Fetch
                      </>
                    )}
                  </Button>
                </Col>

                {/* ✅ NEW: Download Button */}
                <Col md={3} className="d-flex align-items-end">
                  <Button
                    className="w-100 fw-semibold"
                    variant="primary"
                    onClick={handleDownload}
                    disabled={downloadLoading || !categoryId}
                    style={{ height: "35px", fontSize: "0.85rem" }}
                    title={
                      !categoryId
                        ? "Select a category to enable download"
                        : `Download ${selectedCategoryName} Menu Ingredients`
                    }
                  >
                    {downloadLoading ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Downloading...
                      </>
                    ) : (
                      <>
                        <i className="ri-download-2-line me-2"></i>
                        Download
                      </>
                    )}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Results */}
          {/* {isClicked ? (
            <Card className="border-0 shadow-sm rounded-1">
              <Card.Body className="p-3">
                {filteredData?.length > 0 ? (
                  <>
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
                      <div>
                        <h6
                          className="mb-1 fw-semibold"
                          style={{ color: "#0f172a" }}
                        >
                          INGREDIENTS LIST
                        </h6>
                        <div style={{ fontSize: "0.8rem", color: "#64748b" }}>
                          Showing {getPaginatedData().length} of{" "}
                          {filteredData.length} records
                        </div>
                      </div>

                      <Badge
                        bg="light"
                        text="dark"
                        pill
                        style={{
                          fontSize: "0.75rem",
                          padding: "0.5rem 0.75rem",
                          border: "1px solid #e2e8f0",
                        }}
                      >
                        Click on a menu item to view details
                      </Badge>
                    </div>

                    {(menuAccess?.includes("MenuIngredients:get") ||
                      email === "contact@xpansecafe.com") && (
                      <ReusableTable
                        columns={columns}
                        data={getPaginatedData()}
                        rowKey="serialNumber"
                        loading={isLoading}
                        currentPage={page}
                        recordsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        onRecordsPerPageChange={handleRowsPerPageChange}
                        totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                        className="table-hover align-middle"
                        tableStyle={{ fontSize: "0.85rem" }}
                      />
                    )}
                  </>
                ) : (
                  <div className="text-center py-5">
                    <i
                      className="ri-restaurant-line"
                      style={{ fontSize: "2rem", color: "#cbd5e1" }}
                    ></i>
                    <h6 className="mt-2 mb-1" style={{ color: "#64748b" }}>
                      No ingredients found
                    </h6>
                    <p
                      className="mb-0"
                      style={{ fontSize: "0.82rem", color: "#94a3b8" }}
                    >
                      Try a different category or search term.
                    </p>
                  </div>
                )}
              </Card.Body>
            </Card>
          ) : (
            <Card className="border-0 shadow-sm rounded-4">
              <Card.Body className="p-5 text-center">
                <i
                  className="ri-restaurant-line"
                  style={{ fontSize: "2rem", color: "#cbd5e1" }}
                ></i>
                <h6 className="mt-3 mb-1" style={{ color: "#64748b" }}>
                  No data loaded yet
                </h6>
                <p
                  className="mb-0"
                  style={{ fontSize: "0.85rem", color: "#94a3b8" }}
                >
                  Select a category and click Fetch Ingredients.
                </p>
              </Card.Body>
            </Card>
          )} */}
          {/* Results */}
          {isLoading ? (
            <Card className="border-0 shadow-sm rounded-1">
              <Card.Body className="p-3">
                <div className="d-flex justify-content-center align-items-center py-5">
                  <Spinner animation="border" style={{ color: "#0E4961" }} />
                  <span className="ms-3" style={{ color: "#64748b", fontSize: "0.85rem" }}>
                    Loading ingredients...
                  </span>
                </div>
              </Card.Body>
            </Card>
          ) : isClicked ? (
            <Card className="border-0 shadow-sm rounded-1">
              <Card.Body className="p-3">
                {filteredData?.length > 0 ? (
                  <>
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
                      <div>
                        <h6
                          className="mb-1 fw-semibold"
                          style={{ color: "#0f172a" }}
                        >
                          INGREDIENTS LIST
                        </h6>
                        <div style={{ fontSize: "0.8rem", color: "#64748b" }}>
                          Showing {getPaginatedData().length} of{" "}
                          {filteredData.length} records
                        </div>
                      </div>

                      <Badge
                        bg="light"
                        text="dark"
                        pill
                        style={{
                          fontSize: "0.75rem",
                          padding: "0.5rem 0.75rem",
                          border: "1px solid #e2e8f0",
                        }}
                      >
                        Click on a menu item to view details
                      </Badge>
                    </div>

                    {(menuAccess?.includes("MenuIngredients:get") ||
                      email === "contact@xpansecafe.com") && (
                        <ReusableTable
                          columns={columns}
                          data={getPaginatedData()}
                          rowKey="serialNumber"
                          loading={isLoading}
                          currentPage={page}
                          recordsPerPage={rowsPerPage}
                          onPageChange={handlePageChange}
                          onRecordsPerPageChange={handleRowsPerPageChange}
                          totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                          className="table-hover align-middle"
                          tableStyle={{ fontSize: "0.85rem" }}
                        />
                      )}
                  </>
                ) : (
                  <div className="text-center py-5">
                    <i
                      className="ri-restaurant-line"
                      style={{ fontSize: "2rem", color: "#cbd5e1" }}
                    ></i>
                    <h6 className="mt-2 mb-1" style={{ color: "#64748b" }}>
                      No ingredients found
                    </h6>
                    <p
                      className="mb-0"
                      style={{ fontSize: "0.82rem", color: "#94a3b8" }}
                    >
                      Try a different category or search term.
                    </p>
                  </div>
                )}
              </Card.Body>
            </Card>
          ) : (
            <Card className="border-0 shadow-sm rounded-4">
              <Card.Body className="p-5 text-center">
                <i
                  className="ri-restaurant-line"
                  style={{ fontSize: "2rem", color: "#cbd5e1" }}
                ></i>
                <h6 className="mt-3 mb-1" style={{ color: "#64748b" }}>
                  No data loaded yet
                </h6>
                <p
                  className="mb-0"
                  style={{ fontSize: "0.85rem", color: "#94a3b8" }}
                >
                  Select a category and click Fetch Ingredients.
                </p>
              </Card.Body>
            </Card>
          )}
        </div>
      </div>

      {/* Delete Modal */}
      <Modal
        show={openDeleteModal}
        onHide={() => setOpenDeleteModal(false)}
        centered
        size="sm"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title style={{ fontSize: "1rem", color: "#0f172a" }}>
            Confirm Delete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0" style={{ fontSize: "0.85rem", color: "#475569" }}>
            Are you sure you want to delete this ingredient?
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="light"
            onClick={() => setOpenDeleteModal(false)}
            className="rounded-pill px-3"
            style={{ fontSize: "0.82rem" }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDeleteProductIngredient}
            disabled={isLoading}
            className="rounded-pill px-3"
            style={{ fontSize: "0.82rem" }}
          >
            {isLoading ? <Spinner size="sm" /> : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default MenuIngredients;